var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#4D1DF7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2590_15459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6611 10.3476C19.9036 8.58728 17.427 7.74485 14.9608 8.06779C12.4946 8.39062 10.3185 9.84269 9.07374 11.9964C7.82885 14.1503 7.65704 16.7598 8.60751 19.0583C9.55868 21.3569 11.5247 23.0825 13.9272 23.7268C16.3297 24.3711 18.8951 23.8619 20.8688 22.3476C22.8425 20.8339 24 18.4881 24 16.0005C23.9993 13.8806 23.1583 11.8481 21.6611 10.3476ZM21.3563 20.7612L19.1948 18.5997C19.7927 17.8654 20.1196 16.9475 20.1196 16.0005C20.1196 15.0536 19.7926 14.1355 19.1948 13.4013L21.3563 11.2398C22.5236 12.5512 23.1679 14.245 23.1679 16.0005C23.1679 17.7561 22.5236 19.4498 21.3563 20.7612ZM13.6889 18.3227C13.0737 17.7075 12.7287 16.8728 12.7287 16.0027C12.7287 15.1326 13.0744 14.2985 13.6903 13.6833C14.3054 13.0681 15.1395 12.7224 16.0096 12.7224C16.8797 12.7224 17.7138 13.0681 18.329 13.6833C18.9448 14.2985 19.2905 15.1326 19.2905 16.0027C19.2905 16.8727 18.9455 17.7076 18.3303 18.3227C17.7145 18.9379 16.8797 19.2836 16.0096 19.2836C15.1395 19.2836 14.3048 18.9379 13.6889 18.3227ZM20.7689 10.6525L18.6074 12.814C17.8731 12.2161 16.9552 11.8891 16.0082 11.8891C15.0613 11.8891 14.1432 12.2161 13.409 12.814L11.2475 10.6525C12.5589 9.48654 14.2534 8.84227 16.0082 8.84227C17.7631 8.84227 19.4574 9.48654 20.7689 10.6525ZM10.6601 11.2399L12.8217 13.4014C12.2238 14.1357 11.8968 15.0537 11.8968 16.0006C11.8968 16.9476 12.2238 17.8656 12.8217 18.5998L10.6601 20.7613C9.49285 19.4499 8.84855 17.7562 8.84855 16.0006C8.84855 14.2451 9.49281 12.5514 10.6601 11.2399ZM11.2476 21.3487L13.4091 19.1872C14.1427 19.7857 15.0614 20.1127 16.0083 20.1127C16.9553 20.1127 17.874 19.7857 18.6075 19.1872L20.769 21.3487C19.4569 22.5132 17.7632 23.1568 16.0083 23.1568C14.2535 23.1568 12.5598 22.5132 11.2476 21.3487Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2590_15459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon5);
export default __webpack_public_path__ + "static/media/nav_icon_5.85b3fdfc2025c476abb33da8d64f27ca.svg";
export { ForwardRef as ReactComponent };